export const selectActiveLanguage = (state) => state.navbarReducer.get('currentLanguage', 'bos');
